<template>
  <PublicLayout>
    <h1 class="public__title">Politique de confidentialité</h1>
    <p class="public__lead">
     Les informations concernant la collecte et protection des données par Saineo est détaillée ici. Mise à jour : 08/03/2026.
    </p>

    <h2 class="public__section-title">Données collectées</h2>
    <ul class="public__list">
      <li>Informations de compte (email, préférences)</li>
      <li>Données de profil nutritionnel (allergies, objectifs)</li>
      <li>Données d’usage pour améliorer le service</li>
    </ul>

    <h2 class="public__section-title">Vos droits</h2>
    <p class="public__text">
      Vous pouvez demander l’accès, la correction ou la suppression de vos données à tout moment.
    </p>
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'PrivacyPage',
  components: { PublicLayout },
};
</script>
